export default __webpack_public_path__ + "static/portfolio_gallery_18-cc7c09d7f687da46a173b5b645987ce4.jpg";